export default __webpack_public_path__ + "static/media/OM.95fa0b0b.ico";